import type { GridValidRowModel } from "@mui/x-data-grid-premium";
import { getSelectValue } from "./getSelectValue";
import type { SelectValueProp } from "./system.types";

export const getResourceBySelectValue = <
  Resource extends GridValidRowModel = GridValidRowModel,
>({
  value,
  resources,
  valueProp,
}: {
  resources: Resource[];
  value: any;
  valueProp?: SelectValueProp<Resource>;
}) => {
  return resources.find(
    (item) =>
      getSelectValue({
        item: item,
        valueProp,
      }) === value,
  );
};
